// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { GeoJsonEditMode } from "./geojson-edit-mode.js";
export class CompositeMode extends GeoJsonEditMode {
    _modes;
    constructor(modes) {
        super();
        this._modes = modes;
    }
    _coalesce(callback, resultEval = null) {
        let result = null;
        for (let i = 0; i < this._modes.length; i++) {
            // eslint-disable-next-line callback-return
            result = callback(this._modes[i]);
            if (resultEval ? resultEval(result) : result) {
                break;
            }
        }
        return result;
    }
    handleClick(event, props) {
        this._coalesce((handler) => handler.handleClick(event, props));
    }
    handlePointerMove(event, props) {
        return this._coalesce((handler) => handler.handlePointerMove(event, props));
    }
    handleStartDragging(event, props) {
        return this._coalesce((handler) => handler.handleStartDragging(event, props));
    }
    handleStopDragging(event, props) {
        return this._coalesce((handler) => handler.handleStopDragging(event, props));
    }
    handleDragging(event, props) {
        return this._coalesce((handler) => handler.handleDragging(event, props));
    }
    getGuides(props) {
        // TODO: Combine the guides *BUT* make sure if none of the results have
        // changed to return the same object so that "guides !== this.state.guides"
        // in editable-geojson-layer works.
        const allGuides = [];
        for (const mode of this._modes) {
            allGuides.push(...mode.getGuides(props).features);
        }
        return {
            type: 'FeatureCollection',
            features: allGuides
        };
    }
}
